import React, { Component } from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase'
import fire from './fire'

import Writing from './writing';
import WhoToUse from './whoToUse';
import WritingSelector from './writingSelector';
// import ChangeText from './scripts/text-rotator';
import Heading from './heading';

// import globals from './globals';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-regular-svg-icons'


class App extends Component {
  static whyDidYouRender = true;

  // Configure FirebaseUI.
  uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    credentialHelper: 'none',
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: (authResult, redirectUrl) => {
        var user = authResult.user;
        var isNewUser = authResult.additionalUserInfo.isNewUser;

        if (isNewUser){
          this.createAuthor(user);
        }
        return false;
      },
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      currentAuthor: null,
      authorDisplayNames: null,
      betterWritings: new Map(),
      selectedWriting: null,
      notice: null,
      isSignedIn: false,
      writingPendingLoad: null,
    };

    this.checkForWritingPendingLoad();
    this.loadAuthorDisplayNames();
    this.firebaseAuthObserver();
  }

  // componentDidMount() {
  //   ChangeText();
  // }

  // Make sure we un-register Firebase observers when the component unmounts.
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  loadBetterWritings(author){
    //console.log("loading better writings");
    fire.firestore().collection("writings").where('authors', 'array-contains', author).limit(30).onSnapshot((myWritingsCollection) => {
      //console.log(myWritingsCollection);
      let writingsMap = new Map();
      myWritingsCollection.docs.forEach( (writing) => {
        writingsMap.set(writing.id, writing.data().title);
      });
      //console.log(writingsMap);
      if (writingsMap !== this.state.betterWritings) { this.setState({ betterWritings: writingsMap }); }
    });
  }

  loadAuthorDisplayNames(){
    fire.firestore().collection("authors").onSnapshot((authorsCollection) => {
      let data_map = new Map();
      //console.log(authorsCollection);

      authorsCollection.docs.forEach( (author) => {
        // console.log(author.id);
        // console.log(author.data().displayName);
        //alert("author data: " + JSON.stringify(author.data()));
        data_map[author.id] = author.data().displayName;
        //alert("datamap: " + JSON.stringify(data_map));

      });

      if (data_map !== this.state.authorDisplayNames) { this.setState({ authorDisplayNames: data_map }); }
    });
  }

  firebaseAuthObserver() {
    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
        (user) => {
          console.log("auth state changed:" + user);
          if (user){
            fire.firestore().collection("authors").doc(user.uid).get().then((author_obj) => {
              if (author_obj.exists){
                this.loadBetterWritings(author_obj.id);

                if (this.state.writingPendingLoad){
                  let writing_id = this.state.writingPendingLoad;
                  fire.firestore().collection("writings").doc(writing_id).update({
                    authorDisplayNames: firebase.firestore.FieldValue.arrayUnion(user.displayName),
                    authors: firebase.firestore.FieldValue.arrayUnion(author_obj.id),
                  });

                  this.setState({
                    writingPendingLoad: null,
                    selectedWriting: writing_id,
                    currentAuthor: author_obj.id,
                  });
                } else {
                  // simply record this user as logged in
                  this.setState({
                    currentAuthor: author_obj.id,
                    ...author_obj.data()
                  });
                }
              };
            });
          }
          this.setState({isSignedIn: !!user});
        }
    );
  }

  checkForWritingPendingLoad(){
    let path = window.location.pathname;
    if (path !== '/'){ //default url
      let possibleWriting = path.split('/').pop();
      if (possibleWriting === ""){ return; }

      fire.firestore().collection("writings").doc(possibleWriting).get().then((writing) => {
        if (writing.exists) {
          //console.log("yes there is a writing called " + writing.data().title);
          // If user is logged in, add this writing to their writing list, and select it.
          this.setState({writingPendingLoad: writing.id, notice: "You've following a link to collaborate on a document titled \""+writing.data().title+"\". Please sign in to view and edit this document."});
        } else {
          alert("There is no document at the URL you loaded. Please check with a collaborator that the document is not deleted. The document ID you followed was: " + possibleWriting);
        }
        window.history.pushState('', '', '/');

      }).catch((e)=>this.handleError(e));

    }
  }


  createAuthor(user){
    console.log("creating author. user obj:");
    console.log(user);
    fire.firestore().collection("authors").doc(user.uid).set({
      displayName: user.displayName,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }


  firestore_author(){
    return fire.firestore().collection("authors").doc(this.state.currentAuthor);
  }

  handleWritingSelection(writing){
    console.log("setting selected writing to:");
    console.log(writing);
    this.setState({selectedWriting: writing});
  }

  handleNewWriting(){
    fire.firestore().collection("writings").add({
      title: "Untitled Document",
      creator: this.state.currentAuthor,
      authors: [this.state.currentAuthor],
      authorDisplayNames: [firebase.auth().currentUser.displayName],
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    }).then((docRef) => {
      this.setState({selectedWriting: docRef.id});
    });
  }

  handleDeleteWriting(writing){
    if (window.confirm("You will no longer see this document on DemDoc. To recover it, you will need another co-author to share the link back with you. Are you sure you want to remove this document from your document list?")){
      fire.firestore().collection("writings").doc(writing).update({authorDisplayNames: firebase.firestore.FieldValue.arrayRemove(firebase.auth().currentUser.displayName), authors: firebase.firestore.FieldValue.arrayRemove(this.state.currentAuthor)});
      this.setState({selectedWriting: null});
    }
  }

  setCurrentAuthor(author_obj){
    this.setState({
      currentAuthor: (author_obj ? author_obj.id : null),
    });
  }


  signOut(){
    this.setCurrentAuthor(null);
    firebase.auth().signOut();
  }



  handleError(error){
    console.log("Error getting document: ", error);
  }

  render() {
    console.log("Rendering...");
    //alert(JSON.stringify(this.state.authorDisplayNames));

    return (
      <div>

        <div className="app-bar">
          { this.state.selectedWriting &&
            <span id="left-navigation" onClick={()=>this.handleWritingSelection(null)}>&larr; All Documents</span>
          }

          DemDoc

          {this.state.boogers}

          <span id="right-navigation">
            { this.state.isSignedIn &&
              <span>
                <FontAwesomeIcon icon={faUser} />&nbsp;

                {firebase.auth().currentUser.displayName}&nbsp;&nbsp;&nbsp;
                <span onClick={() => this.signOut()}>(Sign Out)</span>
              </span>
            }
          </span>

        </div>
        { !this.state.currentAuthor &&
          <div className="internal-frame">
            <div className="writing">

              {this.state.notice &&
                <div id="notice">
                  {this.state.notice}
                </div>
              }


              {!this.state.notice &&
                <div id="splash">
                  <Heading/>
                  <iframe width="900" height="620" src="https://www.youtube.com/embed/Ed34isX3Isk"  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              }


              <div>
                <div id="side_pitch">

                  <p>

                    <h2>DemDoc enables <span class="highlight4">Self-Governing Groups</span> and <span class="highlight4">Policy-Making Bodies</span> to create documents with strong member buy-in.</h2><br/>


                    <hr/>
                    <h3>How does it work?</h3>
                    <div><span class="highlight2">1</span> You Invite Co-Authors to Co-Create a Document</div>
                    <div><span class="highlight2">2</span> Co-Authors Add Wording & Make Edits</div>
                    <div><span class="highlight2">3</span> Co-Authors Vote on the Wording & Edits</div>
                    <div><span class="highlight2">4</span> The Document Live Updates Based on Votes</div>
                    <br/>
                    <hr/>


                    {/* Somebody (eg. you) starts a document and shares it with their team members. Their team members become equal co-authors, and disagreements over document wording are resolved through votes. The living document represents the will of the co-authors.
                    */}
                  </p>
                </div>
                <div id="spacer"></div>
                <div id="side_image">
                  <h3>Who is it for?</h3>

                  <ul>
                    <li><span class="highlight2">Self-Governing Groups</span>:
                      <ul>

                        <li>Cooperatives</li>
                        <li>Communities</li>
                        <li>Projects & Collaborations</li>
                        <li>Social Movements</li>
                      </ul>
                    </li>
                    <li><span class="highlight2">Policy-Setting Bodies</span>:
                      <ul>
                        <li>Housing Associations</li>
                        <li>Industry Associations</li>
                        <li>Unions</li>
                        <li>Local Governments</li>

                      </ul>
                    </li>

                    {/* Any group of people who wants their members to have equal editing power over a document, to give power to each members voice and creating strong buy-in on agreements.
                    */}


                  </ul>


                </div>


                <div id="mc_embed_signup">
                  <a class="button" href="http://eepurl.com/gJIdmz" target="_blank">Get an Email when We Release</a>

                </div>



                { !this.state.isSignedIn &&
                  <div id="firebaseAuthPane">
                    <h1>Sign in to Play with the Beta</h1>
                    <StyledFirebaseAuth
                      uiCallback={ui => ui.disableAutoSignIn()}
                      uiConfig={this.uiConfig}
                      firebaseAuth={firebase.auth()}/>
                    <span>This software is in development; don't be suprised if you encounter bugs.</span>


                  </div>
                }
                {/* <img id="teamwork" src="/images/teamwork.jpg"/> */}
                <center>                <img id="aspentph_logo" src="/images/aspentph_logo.png"/>
                  <br/><br/>
                  Contact: [se/\n /\t se/\n/\hrens d0t org]
                </center>

              </div>

            </div>


          </div>
        }
        { this.state.currentAuthor && !this.state.selectedWriting &&
          <WritingSelector
            betterWritings={this.state.betterWritings}
            handleWritingSelection={(writing)=>{this.handleWritingSelection(writing)}}
            handleNewWriting={()=>{this.handleNewWriting()}}/>
        }
        { /* else */ }
        { this.state.currentAuthor && this.state.selectedWriting &&
          <Writing
            authorDisplayNames={this.state.authorDisplayNames}
            currentAuthor={this.state.currentAuthor}
            selectedWriting={this.state.selectedWriting}
            handleDeleteWriting={(writing)=>this.handleDeleteWriting(writing)}
          />
        }
        { false &&
          <div id="help-info">
            <WhoToUse/>
          </div>
        }

        <div id="programmerNotes">
          A {this.state.currentAuthor}&nbsp;
          W {this.state.selectedWriting}
        </div>

      </div>
    );

  }
}

export default App;
